<template>
  <zen-one
    :showuserinfo="false"
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Senarai: Penghutang" >

            <w-card bg-color="z-pale-white" class="mt4">
                 <template #title>
                    Carian
                </template>
                <w-flex justify-left align-left>
                    <div class="xs4">
                         <w-select label="Akaun" :items="[{label: 'L100001 | PEMIUTANG'}]" />
                    </div>
                    &nbsp;
                    <div class="xs4" align="center">
                        <w-input type="date">Pada</w-input>
                    </div>
                    <div class="xs2" align="right">
                        <w-checkbox>Papar Baki Sifat</w-checkbox>
                    </div>
                </w-flex>
                 <w-flex justify-left align-left>
                    <div class="xs4">
                        <w-input label="Amaun"></w-input>
                    </div>
                    &nbsp;
                    <div class="xs4" align="center">
                        <w-input label="Hingga"></w-input>
                    </div>
                    <div class="xs4" align="right">
                        <w-input label="Kata Kunci"></w-input>
                    </div>
                </w-flex>
                 <w-flex class="mt3 mb3" wrap align-center justify-end>
                      <div class="text-right">
                          <w-button v-on:click="isHidden = !isHidden">
                              <w-icon>fal fa-search</w-icon>&nbsp;Cari
                          </w-button>
                          {{ report }}
                      </div>
                    </w-flex>
                <br>
             </w-card>

        <template v-if="isHidden">
            <w-card bg-color="z-pale-white" class="mt4">
                <template #title>
                    Butiran
                </template>
                <w-card bg-color="z-pale-white" class="mt4">
                    <w-flex justify-center align-center>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Pada :
                            </h5>
                             <div class="fw-normal my1 fs-1"> 31/12/2020 </div>
                        </div>
                        <div class="xs4" align="center">
                            <w-switch class="mr6" v-model="value"></w-switch>
                        </div>
                        <div class="xs4" align="right">
                            <w-button class="my1" type="submit" >
                                <w-icon dark tile >fal fa-print</w-icon>
                            </w-button>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Jumlah Amaun (RM) :
                            </h5>
                             <div class="fw-normal my1 fs-1"> RM 0.00 Hingga RM 0.00 </div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Kata Kunci Carian :
                            </h5>
                             <div class="fw-normal my1 fs-1"> Tiada Maklumat </div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Jumlah Rekod :
                            </h5>
                             <div class="fw-normal my1 fs-1"> 1 </div>
                        </div>
                    </w-flex>
                    <br>
                 <br>
                     <w-flex justify-center align-center>
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th width="5%" class="w-table__header w-table__header--sortable text-center" rowspan="2">Bil.</th>
                                    <th width="20%" class="w-table__header w-table__header--sortable text-center" rowspan="2">No. ID</th>
                                    <th width="50%" class="w-table__header w-table__header--sortable text-center" rowspan="2">Nama</th>
                                    <th width="25%" class="w-table__header w-table__header--sortable text-center">Amaun (RM)</th>
                                </tr>
                                <tr>
                                    <th width="25%" class="w-table__header w-table__header--sortable text-right">1000.00</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>TH00001</td>
                                    <td>ADAM MAJU NIAGA</td>
                                    <td>1000.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </w-flex>
                    <br>
                 <br><br>
                 </w-card>

                <w-card bg-color="z-pale-white" class="mt4">
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                No. ID :
                            </h5>
                             <div class="fw-normal my1 fs-1"> 31/12/2020 </div>
                        </div>
                        <div class="xs4" align="right">

                        </div>
                        <div class="xs4" align="right">
                            <w-button class="my1" type="submit" >
                                <w-icon dark tile >fal fa-print</w-icon>
                            </w-button>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Nama :
                            </h5>
                             <div class="fw-normal my1 fs-1"> ADAM MAJU NIAGA</div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Pada :
                            </h5>
                             <div class="fw-normal my1 fs-1"> 31/12/2020 </div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Rekod :
                            </h5>
                             <div class="fw-normal my1 fs-1"> 1 </div>
                        </div>
                    </w-flex>
                    <br>
                     <w-flex justify-center align-center>
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center" >Tarikh</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center" >Butiran</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">No. Rujukan</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">No. Dokumen</th>
                                    <th width="20%" class="w-table__header w-table__header--sortable text-center">CAA</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">Keterangan</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">Debit (RM)</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">Kredit (RM)</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">Baki (RM)</th>
                                </tr>

                            </thead>
                            <tbody>
                                 <tr>
                                    <td colspan="6">Carta Akaun : L100001 | PEMIUTANG</td>
                                    <td  class="w-table__header w-table__header--sortable text-right"></td>
                                    <td class="w-table__header w-table__header--sortable text-right">1000.00</td>
                                    <td  class="w-table__header w-table__header--sortable text-right">1000.00</td>
                                </tr>
                                <tr>
                                    <td  class="w-table__header w-table__header--sortable text-left" colspan="8">Baki Di Bawa Ke Hadapan</td>
                                    <td  class="w-table__header w-table__header--sortable text-right">500.00</td>
                                </tr>
                                <tr>
                                    <td>17/12/2021</td>
                                    <td>INBOIS</td>
                                    <td></td>
                                    <td>INV00001</td>
                                    <td>B00001 | PEMBANGUNAN</td>
                                    <td></td>
                                    <td align="right">0.00</td>
                                    <td align="right">500.00</td>
                                    <td align="right">500.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </w-flex>
                    <br>
                </w-card>
                <br><br>

                <w-card bg-color="z-pale-white" class="mt4">
                    <w-flex justify-center align-center>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Nama :
                            </h5>
                             <div class="fw-normal my1 fs-1"> ADAM MAJU NIAGA </div>
                        </div>
                        <div class="xs4" align="center">
                        </div>
                        <div class="xs4" align="right">
                            <w-button class="my1" type="submit" >
                                <w-icon dark tile >fal fa-print</w-icon>
                            </w-button>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                No. Akaun :
                            </h5>
                             <div class="fw-normal my1 fs-1"> B0001 </div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Tarikh :
                            </h5>
                             <div class="fw-normal my1 fs-1"> 01/12/2021 Hingga 31/12/2021 </div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Nominal :
                            </h5>
                             <div class="fw-normal my1 fs-1"> KREDIT </div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Jenis Akaun :
                            </h5>
                             <div class="fw-normal my1 fs-1"> LIABILITI </div>
                        </div>
                    </w-flex>
                    <br>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">
                                Paras :
                            </h5>
                             <div class="fw-normal my1 fs-1"> 1 </div>
                        </div>
                    </w-flex>
                    <br>
                 <br>
                     <w-flex justify-center align-center>
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th width="5%" class="w-table__header w-table__header--sortable text-center" rowspan="2">Bil.</th>
                                    <th width="25%" class="w-table__header w-table__header--sortable text-center" rowspan="2">Keterangan</th>
                                    <th width="40%" class="w-table__header w-table__header--sortable text-center" colspan="2">Carta Akakun</th>
                                    <th width="30%" class="w-table__header w-table__header--sortable text-center" colspan="3">Amaun (RM)</th>
                                </tr>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-center">No. Akaun</th>
                                    <th class="w-table__header w-table__header--sortable text-center">Keterangan</th>

                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">Debit (RM)</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">Kredit (RM)</th>
                                    <th width="10%" class="w-table__header w-table__header--sortable text-center">Baki (RM)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td align="center">1</td>
                                    <td>FINANCIAL</td>
                                    <td>AK20210001</td>
                                    <td>BANK MAYBANK</td>
                                    <td>0.00</td>
                                    <td>500.00</td>
                                    <td>500.00</td>
                                </tr>
                                <tr>
                                    <td align="center">2</td>
                                    <td>KONVENSIONAL</td>
                                    <td>AK20210002</td>
                                    <td>BANK MUAMALAT MALAYSIA</td>
                                    <td>500.00</td>
                                    <td>0.00</td>
                                    <td>0.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </w-flex>
                    <br>
                 </w-card>

            </w-card>
        </template>

    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'

export default {
  components: {

  },
  el: '#app',
  props: {
    isHidden: false
  },
  data() {
    return {

  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
    jenis:'',
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
      resourceurl: 'deposit',
      reload: true,
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Tunggakan Hasil', route: '/tunggakanhasil' },
      ],
    }
  },
  methods: {
    download(report) {
            console.log('click received', report);
        }

  },
  watch: {

  },
  mounted() {


  },
}
</script>
